module.exports = __webpack_public_path__ + "media/images/faces/male/37-a8e1614ac8e4c8210fa112b28822ac07.jpg";